import { IonCol, IonIcon, IonItem, IonRow, IonSelect, IonSelectOption } from "@ionic/react"
import { useEffect, useState } from "react"
import {star, starOutline} from 'ionicons/icons'
import AE2Input from "../../elements/AE2Input"

interface Props{
    setParentForm:Function
    formErrors:[errors:any,setErrors:Function]
}

const startingForm = {
totalGrossFloorArea : "",
totalGrossFloorArea_units : "",
totalGrossFloorArea_date : "",
percentUsedForColdStorage : "",
percentUsedForColdStorage_date : "",
numberOfWalkInRefrigerationUnits : "",
numberOfWalkInRefrigerationUnits_date : "",
weeklyOperatingHours : "",
weeklyOperatingHours_date : "",
percentCooled : "",
percentCooled_date : "",
percentHeated : "",
percentHeated_date : "",
clearHeight : "",
clearHeight_units : "",
clearHeight_date : "",
}
const startErrors = {
totalGrossFloorArea : "GFA cannot be empty",
totalGrossFloorArea_units : "Units cannot be empty",
totalGrossFloorArea_date : "Date cannot be empty",
percentUsedForColdStorage : "",
percentUsedForColdStorage_date : "",
numberOfWalkInRefrigerationUnits : "",
numberOfWalkInRefrigerationUnits_date : "",
weeklyOperatingHours : "",
weeklyOperatingHours_date : "",
percentCooled : "",
percentCooled_date : "",
percentHeated : "",
percentHeated_date : "",
clearHeight : "",
clearHeight_units : "",
clearHeight_date : "",
}

const DistributionCenter: React.FC<Props> = ({setParentForm,formErrors}) => {

    const [form, setForm] = useState(startingForm)
    const [errors, setErrors] = formErrors
    const handleFormChange = (value:any,name:string) => {
        validate(name,value)
        setForm((prevState) => {
            return {
                ...prevState,
                [name]:value
            }
        } )
        setParentForm({...form, [name]:value},'form')

    }

    const handleError = (name:string,value:any) => {
        setErrors((prevState:any) => {
            return {
                ...prevState,
                [name]:value
            }
        } )

    }

    const getCurrentDate = () => {
        return new Date().getTime();
      };


    useEffect(()=>{
        setErrors((prevState:any) => {
            return {
                ...prevState,
                ...startErrors
            }
        } )
    }, [setErrors])

    const validate = (name:string, value:any) => {
        switch(name){
            case ('totalGrossFloorArea'):
                if (value === ''){
                    handleError('totalGrossFloorArea','Gross Floor Area Cannot be Empty')
                }
                else if (value < 0){
                    handleError('totalGrossFloorArea','GFA must be a positive number')
                }
                else {
                    handleError('totalGrossFloorArea','')
                }
                break;
            case ('totalGrossFloorArea_units'):
                if (value === ''){
                    handleError('totalGrossFloorArea_units','Select gfa units')
                }
                else {
                    handleError('totalGrossFloorArea_units','')
                }
                break;
            case ('totalGrossFloorArea_date'):
                if (value === ''){
                    handleError('totalGrossFloorArea_date','Date cannot be empty')
                }
                else if (new Date(value).getTime() > getCurrentDate()){
                    handleError('totalGrossFloorArea_date','Invalid Date')
                }
                else {
                    handleError('totalGrossFloorArea_date','')
                }
                break;
            case ('weeklyOperatingHours'):
                if (value < 0){
                    handleError('weeklyOperatingHours','Hours must be a positive number')
                }
                else if (value > 168){
                    handleError('weeklyOperatingHours','Hours mush be less than 168')
                }
                else {
                    handleError('weeklyOperatingHours','')
                }
                if( value !== '' && form.weeklyOperatingHours_date === ''){
                    handleError('weeklyOperatingHours_date','Date cannot be empty')
                }
                if( value === '' && form.weeklyOperatingHours_date === ''){
                    handleError('weeklyOperatingHours_date','')
                }
                break;
            case ('weeklyOperatingHours_date'):

                if (form.weeklyOperatingHours !== ''){
                    if (value === ''){
                        handleError('weeklyOperatingHours_date','Date cannot be empty')
                    }
                    else if (new Date(value).getTime() > getCurrentDate()){
                        handleError('weeklyOperatingHours_date','Invalid Date')
                    }
                    else {
                        handleError('weeklyOperatingHours_date','')
                    }
                }
                break;
            case ('numberOfWalkInRefrigerationUnits'):

                if (value < 0){
                    handleError('numberOfWalkInRefrigerationUnits','Must be a positive number')
                }
                else {
                    handleError('numberOfWalkInRefrigerationUnits','')
                }
                if( value !== '' && form.numberOfWalkInRefrigerationUnits_date === ''){
                    handleError('numberOfWalkInRefrigerationUnits_date','Date cannot be empty')
                }
                if( value === '' && form.numberOfWalkInRefrigerationUnits_date === ''){
                    handleError('numberOfWalkInRefrigerationUnits_date','')
                }
                break;
            case ('numberOfWalkInRefrigerationUnits_date'):
                if (form.numberOfWalkInRefrigerationUnits !== ''){
                    if (value === ''){
                        handleError('numberOfWalkInRefrigerationUnits_date','Date cannot be empty')
                    }
                    if (new Date(value).getTime() > getCurrentDate()){
                        handleError('numberOfWalkInRefrigerationUnits_date','Invalid Date')
                    }
                    else {
                        handleError('numberOfWalkInRefrigerationUnits_date','')
                    }
                }
                break;
            case ('percentUsedForColdStorage'):
                if (value < 0){
                    handleError('percentUsedForColdStorage','Must be a positive number')
                }
                else if (value > 100){
                    handleError('percentUsedForColdStorage','Max value is 100')
                }
                else {
                    handleError('percentUsedForColdStorage','')
                }

                if( value !== '' && form.percentUsedForColdStorage_date === ''){
                    handleError('percentUsedForColdStorage_date','Date cannot be empty')
                }
                else if( value === '' && form.percentUsedForColdStorage_date === ''){
                    handleError('percentUsedForColdStorage_date','')
                }
                else {
                    handleError('percentUsedForColdStorage','')
                }
                break;
            case ('percentUsedForColdStorage_date'):
                if (form.percentUsedForColdStorage !== ''){
                    if (value === ''){
                        handleError('percentUsedForColdStorage_date','Date cannot be empty')
                    }
                    if (new Date(value).getTime() > getCurrentDate()){
                        handleError('percentUsedForColdStorage_date','Invalid Date')
                    }
                    else {
                        handleError('percentUsedForColdStorage_date','')
                    }
                }
                break;
            case ('percentCooled'):
                if( value !== '' && form.percentCooled_date === ''){
                    handleError('percentCooled_date','Date cannot be empty')
                }
                else if( value === '' && form.percentUsedForColdStorage_date === ''){
                    handleError('percentCooled_date','')
                }
                else {
                    handleError('percentCooled','')
                }
                break;
            case ('percentCooled_date'):
                if (form.percentUsedForColdStorage !== ''){
                    if (value === ''){
                        handleError('percentCooled_date','Date cannot be empty')
                    }
                }
                if (new Date(value).getTime() > getCurrentDate()){
                        handleError('percentCooled_date','Invalid Date')
                    }
                else {
                        handleError('percentCooled_date','')
                    }

                break;
            case ('percentHeated'):
                if( value !== '' && form.percentHeated_date === ''){
                    handleError('percentHeated_date','Date cannot be empty')
                }
                else if( value === '' && form.percentUsedForColdStorage_date === ''){
                    handleError('percentHeated_date','')
                }
                else {
                    handleError('percentHeated','')
                }
                break;
            case ('percentHeated_date'):
                if (form.percentUsedForColdStorage !== ''){
                    if (value === ''){
                        handleError('percentHeated_date','Date cannot be empty')
                    }
                }
                if (new Date(value).getTime() > getCurrentDate()){
                        handleError('percentHeated_date','Invalid Date')
                    }
                else {
                        handleError('percentHeated_date','')
                    }

                break;
            case ('clearHeight'):
                if( value !== ''){
                    value < 0 ? handleError("clearHeight",'Must be a positive number') : handleError('clearHeight','')
                    form.clearHeight_date === '' ? handleError('clearHeight_date','Date cannot be empty') : handleError('clearHeight_date','')
                    form.clearHeight_units === '' ? handleError('clearHeight_units','Select Units') : handleError('clearHeight_units','')
                }
                else {
                    handleError('clearHeight','')
                    handleError('clearHeight_units','')
                    handleError('clearHeight_date','')
                }
                break;
            case ('clearHeight_units'):
                if( value !== ''){
                    form.clearHeight_date === '' ? handleError('clearHeight_date','Date cannot be empty') : handleError('clearHeight_date','')
                    form.clearHeight === '' ? handleError('clearHeight',' Cannot be empty') : handleError('clearHeight','')
                }
                else {
                    handleError('clearHeight','')
                }
                break;
            case ('clearHeight_date'):
                if( value !== ''){
                    new Date(value).getTime() > getCurrentDate() ? handleError('clearHeight_date','Invalid Date') : handleError('clearHeight_date','')
                    form.clearHeight_units === '' ? handleError('clearHeight_units','Select Units') : handleError('clearHeight_units','')
                    form.clearHeight === '' ? handleError('clearHeight',' Cannot be empty') : handleError('clearHeight','')
                }
                else {
                    handleError('clearHeight','')
                    handleError('clearHeight_units','')
                    handleError('clearHeight_date','')
                }
                break;
            default:
                break;
        }
    }

    return (
        <div>
            <h1>Distribution Center</h1>
            <IonRow>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input type="number" errorText={errors.totalGrossFloorArea}  value={form.totalGrossFloorArea} placeholder='GFA' onIonInput={e => (handleFormChange(e.detail.value!,'totalGrossFloorArea'))}>
                        <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Total Gross Floor Area:</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                    <div style={{width:'100%'}}>
                        <IonSelect label="Units" className={errors.totalGrossFloorArea_units === '' ? "valid":'invalid'} value={form.totalGrossFloorArea_units} interface='popover' placeholder='Units' onIonChange={e => (handleFormChange(e.detail.value!,'totalGrossFloorArea_units'))}>
                            <IonSelectOption value={'Square Feet'}>Square Feet</IonSelectOption>
                            <IonSelectOption value={'Square Meters'}>Square Meters</IonSelectOption>
                        </IonSelect>
                        <div className="error-detail">{errors.totalGrossFloorArea_units}</div>
                        </div>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.totalGrossFloorArea_date} value={form.totalGrossFloorArea_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'totalGrossFloorArea_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <AE2Input type="number" labelPlacement="stacked" errorText={errors.percentUsedForColdStorage}  value={form.percentUsedForColdStorage} placeholder='% Cold Storage' onIonInput={e => (handleFormChange(e.detail.value!,'percentUsedForColdStorage'))}>
                        <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Percent used for cold storage</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.percentUsedForColdStorage_date}  value={form.percentUsedForColdStorage_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'percentUsedForColdStorage_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <AE2Input label="Number of Walk-In Refrigeration Units:" labelPlacement="stacked" type="number" errorText={errors.numberOfWalkInRefrigerationUnits}  value={form.numberOfWalkInRefrigerationUnits} placeholder='# Walk-In Refrigeration Units' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfWalkInRefrigerationUnits'))}></AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.numberOfWalkInRefrigerationUnits_date}  value={form.numberOfWalkInRefrigerationUnits_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfWalkInRefrigerationUnits_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <AE2Input type="number" errorText={errors.weeklyOperatingHours}  value={form.weeklyOperatingHours} placeholder='Weekly Hours' onIonInput={e => (handleFormChange(e.detail.value!,'weeklyOperatingHours'))}>
                        <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Weekly Operating Hours</div>
                        </AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.weeklyOperatingHours_date}  value={form.weeklyOperatingHours_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'weeklyOperatingHours_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                    <div style={{width:'100%'}}>
                        <IonSelect className={errors.percentCooled === '' ? "valid":'invalid'}  value={form.percentCooled} interface='popover' placeholder='Percent Cooled' onIonChange={e => (handleFormChange(e.detail.value!,'percentCooled'))}>
                            <IonSelectOption>0</IonSelectOption>
                            <IonSelectOption>10</IonSelectOption>
                            <IonSelectOption>20</IonSelectOption>
                            <IonSelectOption>30</IonSelectOption>
                            <IonSelectOption>40</IonSelectOption>
                            <IonSelectOption>50</IonSelectOption>
                            <IonSelectOption>60</IonSelectOption>
                            <IonSelectOption>70</IonSelectOption>
                            <IonSelectOption>80</IonSelectOption>
                            <IonSelectOption>90</IonSelectOption>
                            <IonSelectOption>100</IonSelectOption>
                            <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Percent Cooled</div>
                        </IonSelect>
                        <div className="error-detail">{errors.percentCooled}</div>
                        </div>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="6" sizeXl="4" >
                    <IonItem lines="none">
                        <AE2Input label='Current as of' type="date" errorText={errors.percentCooled_date}  value={form.percentCooled_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'percentCooled_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="6" sizeXl="4">
                    <IonItem lines="none">
                    <div style={{width:'100%'}}>
                        <IonSelect className={errors.percentHeated === '' ? "valid":'invalid'}  value={form.percentHeated} interface='popover' placeholder='Percent Heated' onIonChange={e => (handleFormChange(e.detail.value!,'percentHeated'))}>
                            <IonSelectOption>0</IonSelectOption>
                            <IonSelectOption>10</IonSelectOption>
                            <IonSelectOption>20</IonSelectOption>
                            <IonSelectOption>30</IonSelectOption>
                            <IonSelectOption>40</IonSelectOption>
                            <IonSelectOption>50</IonSelectOption>
                            <IonSelectOption>60</IonSelectOption>
                            <IonSelectOption>70</IonSelectOption>
                            <IonSelectOption>80</IonSelectOption>
                            <IonSelectOption>90</IonSelectOption>
                            <IonSelectOption>100</IonSelectOption>
                            <div slot="label"><IonIcon slot="start" ios={starOutline} md={star} /> Percent Heated</div>
                        </IonSelect>
                        <div className="error-detail">{errors.percentHeated}</div>
                        </div>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="6" sizeXl="4" >
                    <IonItem lines="none">
                        <AE2Input label="Current as of" type="date" errorText={errors.percentHeated_date}  value={form.percentHeated_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'percentHeated_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Clear height" type="number" errorText={errors.clearHeight}  value={form.clearHeight} placeholder='Clear Height' onIonInput={e => (handleFormChange(e.detail.value!,'clearHeight'))}></AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                    <div style={{width:'100%'}}>
                        <IonSelect label="Units" className={errors.clearHeight_units === '' ? "valid":'invalid'} value={form.clearHeight_units} interface='popover' placeholder='Units' onIonChange={e => (handleFormChange(e.detail.value!,'clearHeight_units'))}>
                            <IonSelectOption value={'Feet'}>Feet</IonSelectOption>
                            <IonSelectOption value={'Meters'}>Meters</IonSelectOption>
                        </IonSelect>
                        <div className="error-detail">{errors.clearHeight_units}</div>
                        </div>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of" type="date" errorText={errors.clearHeight_date} value={form.clearHeight_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'clearHeight_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonItem><IonIcon slot="start" color="white" ios={starOutline} md={star} />Required for Energy Star Score</IonItem>
        </div>
    )
}

export default DistributionCenter